import { render, staticRenderFns } from "./MoleculeEditionProductSatellitesIncludedRuleta.vue?vue&type=template&id=53d90a6a&"
import script from "./MoleculeEditionProductSatellitesIncludedRuleta.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductSatellitesIncludedRuleta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports